export const UpdateAuthenticatedUser = (user: { authenticated: boolean }) => {
    return {
        type: 'USER_AUTHENTICATED',
        user: user,
    }
}

export const UserSignOut = () => {
    return {
        type: 'USER_LOGGED_OUT',
    }
}
